"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cartesian2dTransforms = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * {@inheritDoc ICartesian2dTransforms}
 */
class Cartesian2dTransforms {
    constructor(ctor) {
        const Mat3Ctor = rc_js_util_1.Mat3.getCtor(ctor);
        this.dataToPlotArea = new Mat3Ctor();
        this.dataToInteractiveArea = new Mat3Ctor();
        this.dataToPlotSize = new Mat3Ctor();
        this.dataToInteractiveSize = new Mat3Ctor();
        this.tmp = rc_js_util_1.Range2d.getCtor(ctor).factory.createOneEmpty();
    }
    update(dataRange, plotArea, interactionArea) {
        dataRange.getRangeTransform(plotArea, this.dataToPlotArea);
        dataRange.getRangeTransform(interactionArea, this.dataToInteractiveArea);
        const tmp = this.tmp;
        tmp.setXMax(plotArea.getXRange());
        tmp.setYMax(plotArea.getYRange());
        dataRange.getRangeTransform(tmp, this.dataToPlotSize);
        tmp.setXMax(interactionArea.getXRange());
        tmp.setYMax(interactionArea.getYRange());
        dataRange.getRangeTransform(tmp, this.dataToInteractiveSize);
    }
}
exports.Cartesian2dTransforms = Cartesian2dTransforms;
//# sourceMappingURL=cartesian2d-transforms.js.map